import api from '../api';

function findAll() {
  return new Promise((resolve, reject) => {
    return api.get('/correspondent/person-types')
      .then(response => resolve(response))
      .catch(error => reject(error));
  });
}

export default {
  findAll,
};